import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  Heading,
  Alert,
  AlertIcon,
  Collapse,
  IconButton,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

export default function SensacionTermica() {
  const [temp, setTemp] = useState("");
  const [humedad, setHumedad] = useState("");
  const [resultado, setResultado] = useState(null);
  const [showExplicacion, setShowExplicacion] = useState(false);

  const calcularSensacion = (t, h) => {
    const e = 6.11 * Math.exp(5417.7530 * ((1 / 273.16) - (1 / (t + 273.15))));
    const e_real = e * (h / 100.0);
    const hi = t + 0.5555 * (e_real - 10.0);
    return Math.round(hi * 10) / 10;
  };

  const handleCalcular = () => {
    if (temp && humedad) {
      setResultado(calcularSensacion(parseFloat(temp), parseFloat(humedad)));
    }
  };

  return (
    <Box
      w={{ base: "100%", sm: "90%", md: "500px" }}
      mx="auto"
      mt={6}
      p={{ base: 4, md: 6 }}
      borderWidth={1}
      borderRadius="2xl"
      boxShadow="lg"
      
    >
      <Heading
        as="h2"
        size={{ base: "md", md: "lg" }}
        mb={4}
        textAlign="center"
      >
        Calcula Sensación Térmica
      </Heading>

      <VStack spacing={4}>
        <Input
          type="number"
          placeholder="Temperatura (°C)"
          value={temp}
          onChange={(e) => setTemp(e.target.value)}
          size={{ base: "sm", md: "md" }}
        />
        <Input
          type="number"
          placeholder="Humedad (%)"
          value={humedad}
          onChange={(e) => setHumedad(e.target.value)}
          size={{ base: "sm", md: "md" }}
        />
        <Button
          colorScheme="blue"
          width="100%"
          size={{ base: "sm", md: "md" }}
          onClick={handleCalcular}
        >
          Calcular
        </Button>

        {resultado !== null && (
          <Box mt={4} textAlign="center">
            <Text fontSize={{ base: "md", md: "lg" }} fontWeight="semibold">
              🌡️ Sensación térmica: {resultado} °C
            </Text>
            {resultado > 35 ? (
              <Alert status="error" mt={2} borderRadius="md">
                <AlertIcon />
                ⚠️ Existe riesgo de estrés térmico para trabajadores.
              </Alert>
            ) : (
              <Alert status="success" mt={2} borderRadius="md">
                <AlertIcon />
                ✅ No existe estrés térmico para trabajadores.
              </Alert>
            )}
          </Box>
        )}

        {/* Explicación desplegable */}
        <Box mt={6} w="100%">
          <Button
            variant="outline"
            width="100%"
            onClick={() => setShowExplicacion(!showExplicacion)}
            rightIcon={showExplicacion ? <ChevronUpIcon /> : <ChevronDownIcon />}
          >
            {showExplicacion ? "Ocultar explicación" : "Mostrar explicación"}
          </Button>
          <Collapse in={showExplicacion} animateOpacity>
            <Box mt={4} textAlign="left">
              <Text mb={2} fontWeight="bold">
                Fórmula de cálculo
              </Text>
              <Text mb={2}>
                Se usa el Índice de Calor para estimar la sensación térmica, combinando temperatura y humedad:
              </Text>
              <Text mb={2} fontFamily="monospace">
                HI = T + 0.5555 × (e - 10)
              </Text>
              <Text mb={2} fontFamily="monospace">
                e = 6.11 × exp[5417.7530 × (1/273.16 - 1/(T+273.15))] × RH/100
              </Text>
              <Text mb={2}>
                Donde T es la temperatura en °C y RH la humedad relativa en %. El índice refleja la temperatura percibida por el cuerpo.
              </Text>

              <Text mt={4} mb={2} fontWeight="bold">
                Repercusiones laborales en España (2025):
              </Text>
              <Text mb={2}>
                Según la normativa vigente, las empresas deben evaluar riesgos por exposición al calor y tomar medidas:
              </Text>
              <Text mb={1}>
                • Modificar horarios o pausas de trabajo.  
                • Proveer sombra, agua y ventilación.  
                • Reducir o suspender tareas cuando el riesgo sea alto.
              </Text>
              <Text mb={2}>
                Esto se fundamenta en el Real Decreto-Ley 4/2023 y la Ley de Prevención de Riesgos Laborales, considerando el estrés térmico como riesgo laboral. Ignorar estas medidas puede derivar en sanciones y poner en peligro la salud de los trabajadores.
              </Text>
            </Box>
          </Collapse>
        </Box>
        <Box p={10}></Box>  
      </VStack>
    </Box>
  );
}
